import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Querying...", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"text-decoration":"underline","font-weight":"bold"} }, "Auction Info:")
], -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Contract Address:", -1)
const _hoisted_12 = { style: {"font-weight":"bold"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, "Ends at:", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "Status:", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", null, "Sell Token:", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dt", null, "Sell Amount:", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode()
const _hoisted_21 = /*#__PURE__*/_createElementVNode("dt", null, "Bid Token:", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = /*#__PURE__*/_createElementVNode("dt", null, "Minimum Bid:", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mounting)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeAuctions, (auction) => {
        return (_openBlock(), _createElementBlock("li", {
          key: auction.address
        }, [
          _createTextVNode(_toDisplayString(auction.pair) + " ", 1),
          _createVNode(_component_router_link, {
            onClick: _withModifiers(($event: any) => (_ctx.viewMore(auction.address)), ["prevent"]),
            to: { path: `/auctions/${auction.address}`}
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", { disabled: _ctx.loading }, "View More", 8, _hoisted_4)
            ]),
            _: 2
          }, 1032, ["onClick", "to"])
        ]))
      }), 128))
    ]),
    (_ctx.auctionInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeAuction && _ctx.closeAuction(...args))),
            disabled: _ctx.loading
          }, "Close Auction", 8, _hoisted_7),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkHasBids && _ctx.checkHasBids(...args)))
            }, "Check Bids"),
            (_ctx.hasBids)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "This auction has bids"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.placeBid && _ctx.placeBid(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bid) = $event)),
              placeholder: "Amount"
            }, null, 512), [
              [_vModelText, _ctx.bid]
            ]),
            _createElementVNode("button", { disabled: _ctx.loading }, "Place Bid", 8, _hoisted_9)
          ], 32),
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeMinimumBid && _ctx.changeMinimumBid(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newMinimumBid) = $event)),
              placeholder: "Amount"
            }, null, 512), [
              [_vModelText, _ctx.newMinimumBid]
            ]),
            _createElementVNode("button", { disabled: _ctx.loading }, "Change Minimum Bid", 8, _hoisted_10)
          ], 32),
          _createElementVNode("dl", null, [
            _hoisted_11,
            _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.auctionInfo.auction_address), 1),
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("dd", null, _toDisplayString(_ctx.auctionInfo.ends_at), 1),
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("dd", null, _toDisplayString(_ctx.auctionInfo.status), 1),
            _hoisted_17,
            _hoisted_18,
            _createElementVNode("dd", null, _toDisplayString(_ctx.auctionInfo.sell_token.token_info.name) + " (your balance: " + _toDisplayString(_ctx.sellBalance) + ")", 1),
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("dd", null, _toDisplayString(_ctx.sellAmount), 1),
            _hoisted_21,
            _hoisted_22,
            _createElementVNode("dd", null, _toDisplayString(_ctx.auctionInfo.bid_token.token_info.name) + " (your balance: " + _toDisplayString(_ctx.bidBalance) + ")", 1),
            _hoisted_23,
            _hoisted_24,
            _createElementVNode("dd", null, _toDisplayString(_ctx.minimumBid), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}